import script from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=bee0c062&lang=scss"

const __exports__ = script;

export default __exports__